(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ContactManagerProfileController', [
            'MW.ContactManager.ActiveOn',
            'MW.ContactManager.ContactManagerNavigationService',
            'MW.Framework.InfluencerContactService',
            'MW.ContactManager.ContactManagerFlashService',
            'MW.Framework.TranslationService',
            'MW.ContactManager.ContactManagerPropertyTypeService',
            'MW.CoreStream.ContactManagerTagService',
            'MW.Influencers.IcmDialogService',
            'MW.Framework.ICMEmailService',
            'MW.Framework.CoreGridDefinition',
            'MW.Framework.CoreGridSearchService',
            'MW.Framework.CoreGridSelectableService',
            'MW.ContactManager.OutreachListFactory',
            'MW.Framework.CoreUserService',
            'MW.Framework.CoreCompanyService',
            'MW.Framework.TextFilters',
            'MW.Framework.MomentService',
            'MW.Framework.PageStateService',
            'Configuration',
            'MW.Framework.EntitlementService',
            'MW.Influencers.AnalyticsService',
            'MW.Influencers.FeedbackService',
            'ngMaterial',
            'mwAppComponents',
            'MW.Influencers.ActivityService',
            'MW.Influencers.IcmUnsubscribeService',
            'MW.Influecners.UnsubscribeBadge'
        ])
        .controller('ContactManagerProfileController', [
            'ContactManagerNavigationService',
            'InfluencerContactService',
            'ContactManagerFlashService',
            'translationService',
            'ContactManagerTagService',
            'DialogService',
            'ICMEmailService',
            '$location',
            '$translate',
            '$filter',
            'activeOnTypes',
            'breadcrumbs',
            'contact',
            'CoreGridDefinition',
            'CoreGridSearchService',
            'CoreGridSelectableService',
            'OutreachListFactory',
            'CoreUserService',
            'CoreCompanyService',
            'moment',
            'DEFAULT_MEDIA_LIST',
            'companyId',
            'PageStateService',
            'EntitlementService',
            'AnalyticsService',
            'FeedbackService',
            '$q',
            '$mdDialog',
            '$timeout',
            '$scope',
            'ActivityService',
            'IcmUnsubscribeService',
            ContactManagerProfileController
        ]);

    function ContactManagerProfileController(
        ContactManagerNavigationService,
        InfluencerContactService,
        ContactManagerFlashService,
        translationService,
        ContactManagerTagService,
        DialogService,
        ICMEmailService,
        $location,
        $translate,
        $filter,
        activeOnTypes,
        breadcrumbs,
        contact,
        CoreGridDefinition,
        CoreGridSearchService,
        CoreGridSelectableService,
        OutreachListFactory,
        CoreUserService,
        CoreCompanyService,
        moment,
        DEFAULT_MEDIA_LIST,
        companyId,
        PageStateService,
        EntitlementService,
        AnalyticsService,
        FeedbackService,
        $q,
        $mdDialog,
        $timeout,
        $scope,
        ActivityService,
        UnsubscribeService
    ) {
        this.contact = contact;

        this.ActivityService = ActivityService;
        this.AnalyticsService = AnalyticsService;
        this.FeedbackService = FeedbackService;
        this.CoreGridSearchService = CoreGridSearchService;
        this.CoreGridSelectableService = CoreGridSelectableService;
        this.CoreGridDefinition = CoreGridDefinition;
        this.isPermissions = false;
        this.emailEmptyStateVisible = true;
        this.$translate = $translate;
        this.mediaListTranslation = this.$translate.instant('icm-web-contact-profile__media-lists--label');
        this.$filter = $filter;
        this.moment = moment;
        this.companyId = companyId;
        this.PageStateService = PageStateService;
        this.$mdDialog = $mdDialog;
        this.CoreUserService = CoreUserService;
        this.CoreCompanyService = CoreCompanyService;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$scope = $scope;

        this.UnsubscribeService = UnsubscribeService;

        CoreUserService.hasPermissions().then(function (isPermissions) {
            this.isPermissions = isPermissions;
        }.bind(this)).catch(function(){});

        this.breadcrumbs = breadcrumbs;
        this.activeOnTypes = activeOnTypes;
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.InfluencerContactService = InfluencerContactService;
        this.ContactManagerFlashService = ContactManagerFlashService;
        this.OutreachListFactory = new OutreachListFactory();

        // keep track of what our saved notes are
        this.translationService = translationService;

        this.ContactManagerTagService = ContactManagerTagService;
        this.DialogService = DialogService;
        this.ICMEmailService = ICMEmailService;
        this.isNotesView = true;
        this.isEmailView = false;
        this.coreGridEmailConfig = {};
        this.$location = $location;
        this.isContactOnMediaList = false;
        this.canSendEmail = false;
        var primaryEmail = (this.contact.contactInfo.email[0] && this.contact.contactInfo.email[0].address) ? this.contact.contactInfo.email[0].address : null;

        if (primaryEmail !== null) {
            this.UnsubscribeService.didEmailUnsubscribeFromICM(primaryEmail).then(function unsubscribedRes(response) {
                if (response === true) {
                    this.contact.setUnsubscribedStatus(primaryEmail);
                    this.canSendEmail = false;
                }
                else {
                    this.canSendEmail = true;
                }
            }.bind(this)).catch(function(){});
        }

        /**
         * Responsible for determining if a button should be disabled or not.
         * @returns {boolean} Returns true if the button should be disabled.  Returns false if the button should not be disabled.
         */
        this.isButtonDisabled = function isButtonDisabled() {
            var isDisabled = true;
            if (this.contact !== undefined && this.contact.notes !== undefined) {
                isDisabled = ((this.CoreGridSelectableService.getSelectedDataItems(this.coreGridNotesConfig, this.formatNotes(this.contact.notes))).length > 0 && this.isNotesView) ? false : true;
            }
            return isDisabled;
        }.bind(this);

        /**
         * Initialize the coreGridNotesConfig.  This will be populated later in this file.
         * @type {{}}
         */
        this.coreGridNotesConfig = {};
        this.contactNotesCollection = [];
        this.isInfluencerAppEntitled = false;
        if(CoreUserService.isInfluencerAppEntitled === '') {
            EntitlementService.registerEntitlement('toggle', 'influencerApp', 'Influencers');
            EntitlementService.getInfluencerAppEntitlement()
                .then(function getAccountEntitlementThen(entitlement) {
                    if(entitlement) {
                        this.isInfluencerAppEntitled = true;
                    }
                }.bind(this));
        } else if(CoreUserService.isInfluencerAppEntitled) {
            this.isInfluencerAppEntitled = true;
        }

        // Define the core grid configuration for the ICM Notes list.
        var historyTableCoreGridConfig = {
            dataItemIdProperty: 'notesId',
            headerTemplateUrl: 'icm-web/views/partials/notes_core_grid_table_header',
            bodyTemplateUrl: 'icm-web/views/partials/notes_core_grid_table_body',
            sortable: {
                enabled: true,
                field: 'created',
                descending: true,
                conditionalSort: function(sortField) {
                    if(sortField === 'created') {
                        return 'modifiedTimeStamp';
                    }
                    return sortField;
                }
            },
            actionButtons: [
                {
                    name: 'Delete',
                    isDisabled : this.isButtonDisabled,
                    callback: function(){
                        this.deleteNotesHandler();
                    }.bind(this)
                }
            ],
            columnDefinitions: [
                {
                    name: 'Type',
                    dataKey: 'typeDisplay',
                    options: {
                        defaultValue: 'note',
                        class: 'notesCollectionType',
                        sortable: true,
                        searchable: true
                    }
                },
                {
                    name: 'SUBJECT',
                    dataKey: 'subjectBackup',
                    options: {
                        class: 'notesCollectionSubject',
                        columnDataTemplateUrl: 'icm-web/views/partials/notes_subject_column',
                        clickable: true,
                        onClick: function(dataItem) {
                            this.editActivity(dataItem);
                        }.bind(this)
                    }
                },
                {
                    name: 'DATE',
                    dataKey: 'created',
                    options: {
                        class: 'notesCollectionDate',
                        sortable: true
                    }
                }
            ],
            selectable: {
                singleSelect: false,
                enabled: true,
                selected: []
            },
            searchable: {
                enabled: false
            }
        };

        // change the class to change the width of the column
        historyTableCoreGridConfig.columnDefinitions[1].options.class = 'activityCollectionSubject';
        historyTableCoreGridConfig.columnDefinitions.push({
            name: 'icm-web__contact-profile--activity-table-column-author',
            dataKey: 'authorName',
            options: {
                defaultValue: '',
                class: 'activityAuthor',
                sortable: true,
                searchable: true
            }
        });
        // this injects the author into the 3rd position of the array (before date)
        historyTableCoreGridConfig.columnDefinitions.splice(2, 0, historyTableCoreGridConfig.columnDefinitions.splice(3, 1)[0]);

        // Load the core grid configuration for this page to use
        this.coreGridNotesConfig = this.CoreGridDefinition.build(historyTableCoreGridConfig);

        /**
         * Initialize the coreGridEmailConfig.  This will be populated later in this file.
         * @type {{}}
         */
        this.coreGridEmailConfig = {};
        this.contactEmailCollection = [];
        this.contactEmailArray = [];

        // Define the core grid configuration for the Emails list.
        var historyTableEmailCoreGridConfig = {
            dataItemIdProperty: '_id',
            headerTemplateUrl: 'icm-web/views/partials/outreach_core_grid_table_header',
            bodyTemplateUrl: 'icm-web/views/partials/outreach_core_grid_table_body',
            sortable: {
                enabled: true,
                field: 'name',
                descending: false,
                backendSorting: false,
                conditionalSort: function(sortField) {
                    if(sortField === 'scheduledDate') {
                        return 'scheduledDateStamp';
                    }
                    return sortField;
                }
            },
            actionButtons: [],
            columnDefinitions: [
                {
                    name: 'TYPE',
                    dataKey: 'type',
                    options: {
                        defaultValue: 'email',
                        class: 'collectionType',
                        sortable: false,
                        searchable: true
                    }
                },
                {
                    name: 'SUBJECT',
                    dataKey: 'subject',
                    options: {
                        class: 'collectionSubject',
                        clickable: false,
                        columnDataTemplateUrl: 'icm-web/views/partials/outreach_subject_column',
                        defaultValue: this.translationService.getLocalizedString('No Recipients'),
                        clickCallback: function clickCallback(route) {
                            this.ICMEmailService.getIcmApprovedSenders()
                                .then(function() {
                                    this.$location.url(route);
                                }.bind(this))
                                .catch(function(error) {
                                    if(error) {
                                        this.showUnapprovedDialog();
                                    } else {
                                        this.DialogService.flashError(this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
                                    }
                                }.bind(this));
                        }.bind(this)
                    }
                },
                {
                    name: 'STATUS',
                    dataKey: 'status',
                    options: {
                        class: 'collectionStatus',
                        sortable: true,
                        columnDataTemplateUrl: 'icm-web/views/partials/outreach_status_column'
                    }
                },
                {
                    name: 'Date', //This is lower case to match en.json
                    dataKey: 'scheduledDate',
                    options: {
                        class: 'collectionType',
                        sortable: true,
                        columnDataTemplateUrl: 'icm-web/views/partials/outreach_date_column',
                        defaultValue: this.translationService.getLocalizedString('N/A')
                    }
                }
            ],
            selectable: {
                enabled: false,
                selected: [],
                singleSelect: false
            },
            searchable: {
                enabled: false,
                predictionFields: [],
                searchTerms: []
            }
        };

        // Load the core grid configuration for this page to use
        this.coreGridEmailConfig = this.CoreGridDefinition.build(historyTableEmailCoreGridConfig);
        this.getAllEmails(); // Initializing call to load outreach emails for contact profile page
        if (this.contact.notes) {
            this.contactNotesCollection = this.formatNotes(this.contact.notes).slice(0, 10);
        }

        this.toggleText = {
            more: this.translationService.getLocalizedString('Show More') + ' ',
            less: this.translationService.getLocalizedString('Show Less') + ' '
        };
        this.toggleShowMoreLessText = this.toggleText.more;
        this.showAllMedialist = false;
        this.showLimit = 20;
        this.medialistItems = [];
        this.mediaListsArray = [];
        this.lockerData = [];
        this.defaultMasterListName = DEFAULT_MEDIA_LIST + this.companyId;

        ContactManagerTagService.getAllMediaListsForContactId(contact.id).then(function afterGetMediaLists(data){
            this.contact.mediaLists = data || [];
            this.isContactOnMediaList = this.contact.mediaLists.length === 0 ? false : true;
            this.showInfluencersList();
        }.bind(this))
            .catch(function afterFail(){
                this.contact.mediaLists = contact.mediaLists || [];
                this.isContactOnMediaList = this.contact.mediaLists.length === 0 ? false : true;
        }.bind(this));

        this.lastUpdatedString = '';
        this.lastUpdatedValues = '';
        this.formatLastUpdatedString(contact);
        this.FeedbackService.initializeContact(this.contact);
    }

    ContactManagerProfileController.prototype.showInfluencersList = function showInfluencersList() {
        //getting all mediaLists to display names of Media Lists that contact associated with
        if(this.contact.mediaLists.length) {
            this.ContactManagerTagService.getAllTags().then(function(response) {
                this.medialistItems = response;
                for(var i=0; i < this.medialistItems.length; i++) {
                    if(this.contact.mediaLists && this.contact.mediaLists.indexOf(this.medialistItems[i].id) > -1) {
                        if(this.defaultMasterListName !== this.medialistItems[i].name) {
                            this.mediaListsArray.push({
                                name: this.medialistItems[i].name,
                                lockerData: {
                                    name : this.medialistItems[i].name,
                                    id : this.medialistItems[i].id
                                }
                            });
                        }
                    }
                }
            }.bind(this)).catch(function() {
                this.DialogService.flashError(this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
            }.bind(this));
        }
    };

    ContactManagerProfileController.prototype.editContact = function editContact() {
        this.ContactManagerNavigationService.goToEdit(this.contact.id);
    };

    ContactManagerProfileController.prototype.addThisContactToList = function addThisContactToList(){
        let manageListDialog = document.querySelector('icm-manage-lists-dialog');
        manageListDialog.open([this.contact.id]);
        window.addEventListener('icm-lists-updated', this.refreshLists, {once: true});
    };

    ContactManagerProfileController.prototype.refreshLists = function refreshLists(event) {
        let _this = angular.element(document.getElementsByClassName('contactProfileWrapper')).scope().profileController;
        let newMediaListArray = [];

        if(event && event.detail.updatedLists){
            var updatedLists = event.detail.updatedLists;
            for(var x in updatedLists) { // jshint ignore:line
                let list = updatedLists[x];

                newMediaListArray.push({
                    name: list.listName,
                    lockerData: {
                        name: list.listName,
                        id: list.id
                    }
                });
            }
            _this.mediaListsArray = newMediaListArray;

            _this.$scope.$apply();

            if(_this.mediaListsArray.length > 0){
                _this.isContactOnMediaList = true;
            }else{
                _this.isContactOnMediaList = false;
            }
        }
    };

    ContactManagerProfileController.prototype.removeThisContact = function removeThisContact() {
        var contactTagArray = [];

        function _onSuccess(controller) {
            controller.isContactOnMediaList = false;

            //set contact to null so that it is loaded during next call.
            controller.InfluencerContactService.setCurrentContact(null);

            controller.ContactManagerFlashService.flashSuccess('Success. This contact has been removed from your contacts.');
            controller.ContactManagerNavigationService.smartBackAction();
        }

        function _onFailure(controller) {
            controller.ContactManagerFlashService.flashError('Oops. There was a problem removing this contact. Please try again later.');
        }

        // private contacts should be deleted
        // public contacts should be removed from all media lists
        if(this.contact.systemData.policies.storage.private === true) {
            this.InfluencerContactService.deleteContact(this.contact.id).then(function() {
                _onSuccess(this);
            }.bind(this)).catch(function() {
                _onFailure(this);
            }.bind(this));
        } else {
            contactTagArray = this.mediaListsArray.map(function(mediaList) {
                return {
                    mediaListId: mediaList.lockerData.id,
                    contactId: this.contact.id
                };
            }, this);

            this.ContactManagerTagService.removeContactsFromTags(contactTagArray).then(function() {
                _onSuccess(this);
            }.bind(this)).catch(function() {
                _onFailure(this);
            }.bind(this));
        }
    };

    ContactManagerProfileController.prototype.compose = function compose() {
        this.ICMEmailService.getIcmApprovedSenders().then(function onSuccess(sendersList) {
            if(sendersList.length) {
                this.composeEmail(sendersList);
            } else {
                this.showUnapprovedDialog();
            }
        }.bind(this), function onFailure() {
            this.DialogService.flashError(this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
        }.bind(this));
    };

    ContactManagerProfileController.prototype.showUnapprovedDialog = function() {
        var dialogTitle = this.translationService.getLocalizedString('Compose Email'),
            callback = function callback() {
                this.ContactManagerNavigationService.redirectToFairhairWeb('/settings/email');
            }.bind(this);

        this.DialogService.dialog(dialogTitle, 'icm-web/views/partials/email_unapproved_dialog', {}, callback);
    };

    ContactManagerProfileController.prototype.composeEmail = function composeEmail(senderObject) {
        this.ICMEmailService.resetRecipients();

        this.ICMEmailService.setContactRecipients([this.contact]);
        this.ICMEmailService.setSender(senderObject);

        this.$location.path('/outreach/compose').search('step', '1');
    };

    ContactManagerProfileController.prototype.showMore = function showMore(type){
        this.$location.url('/influencers/contact/showmore/'+this.contact.id + '/' + type);
    };

    ContactManagerProfileController.prototype.toggleNotesEmailView = function toggleNotesEmailView() {
        this.isNotesView = !this.isNotesView;
        this.isEmailView = !this.isEmailView;
    };

    ContactManagerProfileController.prototype.getAllEmails = function getAllEmails(sortField, sortOrder) {
        var contactId = (this.contact && this.contact.id) ? this.contact.id : null,
            emailAddressArray = [],
            i;
        if(this.contact && this.contact.contactInfo && Array.isArray(this.contact.contactInfo.email) && this.contact.contactInfo.email.length) {
            this.contact.contactInfo.email.forEach(function(emailAddressObject) {
                if(emailAddressObject.address && typeof(emailAddressObject.address) ==='string' && emailAddressObject.address.length) {
                    emailAddressArray.push(emailAddressObject.address);
                }
            });
        }

        // Get all outreach emails list
        if(contactId || emailAddressArray.length) {
            this.OutreachListFactory.getAllEmails(contactId, emailAddressArray, sortField, sortOrder, 0, 11).then(function getAllEmailsSuccess(response) {
                if(response && response.hits) {
                    this.contactEmailCollection = [];
                    this.contactEmailArray = response.hits;
                    var length = this.contactEmailArray.length > 10 ? 10 : this.contactEmailArray.length;
                    for (i = 0; i < length ; i++) {
                        this.contactEmailCollection.push(this.contactEmailArray[i]);
                        this.emailEmptyStateVisible = (this.contactEmailCollection.length <= 0);
                    }
                }
            }.bind(this));
        } else {
            this.emailEmptyStateVisible = true;
        }
    };

    ContactManagerProfileController.prototype.formatNotes = function formatNotes(notes) {
        var newNotesArray = [],
            sortedNotes;

        if (Array.isArray(notes) && notes.length) {
            sortedNotes = this.$filter('orderBy')(notes, 'modifiedAt', 'desc');
            sortedNotes.forEach(function(note) {
                if(typeof note.note === 'string' && note.note.length) {
                    if (typeof note.subject !== 'string') {
                        note.subject = '';
                    }

                    newNotesArray.push({
                        notesId: note.id,
                        typeDisplay: note.type ? this.ActivityService.translateActivityType(note.type) : this.ActivityService.translateActivityType('note'),
                        type: note.type || 'note',
                        subject: note.subject,
                        subjectBackup: note.subject || note.note.substring(0, 240),
                        note: note.note,
                        date: note.date,
                        authorName: note.createdBy && note.createdBy.firstName && note.createdBy.lastName ? note.createdBy.firstName + ' ' + note.createdBy.lastName : '',
                        createdBy: note.createdBy,
                        updatedBy: note.updatedBy,
                        created: this.$filter('mwConvertDateToUserTimezone')(note.modifiedAt, 'mediumDate'),
                        createdAt: note.createdAt,
                        modifiedAt: note.modifiedAt,
                        modifiedTimeStamp: this.moment.utc(note.modifiedAt).format('X')
                    });
                }
            }.bind(this));
        }

        return newNotesArray;
    };

    ContactManagerProfileController.prototype.onNotesUpdated = function onNotesUpdated(notePromise) {
        notePromise
            .then(function onSuccess() {
                this.InfluencerContactService.getContactById(this.contact.id).then(function onGetContactSuccess(response) {
                    this.contact = response;
                    this.getNotes(this.contact.id);
                    this.ContactManagerFlashService.flashSuccess('Success. Your contact has been updated.');
                }.bind(this));
            }.bind(this))
            .catch(function onFail(error) {
                if (error.message === 'Add faild') {
                    this.contactNotesCollection.shift();
                }
                this.ContactManagerFlashService.flashError(error);
            }.bind(this));
    };

    ContactManagerProfileController.prototype.getNotes = function getNotes(contactId) {
        // retrieve notes for the contact. since we dont return them for list views they dont get cached in the InfluencerContactService
        this.InfluencerContactService.getNotes(contactId)
            .then(function(notes) {
                this.contact.notes = notes;
                this.contactNotesCollection = this.formatNotes(notes).slice(0, 10);
            }.bind(this))
            .catch(function() {
                this.DialogService.flashError('Failed retrieving notes');
            }.bind(this));
    };

    ContactManagerProfileController.prototype.addActivity = function addActivity() {
        var createActivityPromise = this.ActivityService.createActivity(this.contact.id);
        this.onNotesUpdated(createActivityPromise);
    };

    ContactManagerProfileController.prototype.editActivity = function editActivity(oldNote) {
        var updateActivityPromise = this.ActivityService.updateActivity(this.contact.id, oldNote);
        this.onNotesUpdated(updateActivityPromise);
    };

    ContactManagerProfileController.prototype.deleteNotesHandler = function deleteNotesHandler() {
        var confirmMessageText = this.translationService.getLocalizedString('Are you sure you want to delete the selected note(s)?'),
            confirmMessageTitle = this.translationService.getLocalizedString('Delete note(s)?');

        this.DialogService.confirm(confirmMessageText, confirmMessageTitle, function(payload) {
            if(payload.success) {
                var selectedNotes = this.CoreGridSelectableService.getSelectedDataItems(this.coreGridNotesConfig, this.formatNotes(this.contact.notes)),
                    notesToDelete = [];

                if(selectedNotes.length > 0) {
                    this.CoreGridSelectableService.deleteAllInSelected(this.coreGridNotesConfig);

                    notesToDelete = selectedNotes.map(function(selectedNote) {
                        return selectedNote.notesId;
                    });

                    this.onNotesUpdated(this.InfluencerContactService.deleteNotes(this.contact.id, notesToDelete));
                }
            }
        }.bind(this));
    };

    ContactManagerProfileController.prototype.toggleMedialistView = function toggleMedialistView() {
        if(!this.showAllMedialist) {
            this.showLimit = this.mediaListsArray.length;
            this.toggleShowMoreLessText = this.toggleText.less;
        } else {
            this.showLimit = 20;
            this.toggleShowMoreLessText = this.toggleText.more;
        }
        this.showAllMedialist = !this.showAllMedialist;
    };

    ContactManagerProfileController.prototype.clickOnMediaList = function clickOnMediaList(lockerData) {
        this.$location.url('influencers/contact-list/' + lockerData.id);
    };

    ContactManagerProfileController.prototype.formatLastUpdatedString = function formatLastUpdatedString(contact) {
        var now = null,
            lastUpdated = null;

        if(contact.updated) {
            now = this.moment().utc();
            lastUpdated = this.moment(contact.updated).utc();

            if(now.diff(lastUpdated, 'months') >= 3) {
                this.lastUpdatedString = 'icm-contact-profile__last-updated--months';
                this.lastUpdatedValues = '';
            } else if(now.diff(lastUpdated, 'days') === 1) {
                this.lastUpdatedString = 'icm-contact-profile__last-updated--day';
                this.lastUpdatedValues = now.diff(lastUpdated, 'days');
            } else if (now.diff(lastUpdated, 'days') > 1) {
                this.lastUpdatedString = 'icm-contact-profile__last-updated--days';
                this.lastUpdatedValues = now.diff(lastUpdated, 'days');
            } else if (now.diff(lastUpdated, 'hours') === 1) {
                this.lastUpdatedString = 'icm-contact-profile__last-updated--hour';
                this.lastUpdatedValues = now.diff(lastUpdated, 'hours');
            } else if (now.diff(lastUpdated, 'hours') > 1) {
                this.lastUpdatedString = 'icm-contact-profile__last-updated--hours';
                this.lastUpdatedValues = now.diff(lastUpdated, 'hours');
            } else if (now.diff(lastUpdated, 'minutes') === 1) {
                this.lastUpdatedString = 'icm-contact-profile__last-updated--minute';
                this.lastUpdatedValues = now.diff(lastUpdated, 'minutes');
            } else {
                this.lastUpdatedString = 'icm-contact-profile__last-updated--minutes';
                this.lastUpdatedValues = now.diff(lastUpdated, 'minutes');
            }
        }
    };
}());